import * as React from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'
import { AutocompleteView } from './Autocomplete.view'

interface Props {
  address: string
  updateAddress: (address: any) => void
  onSelect: (selectedAddress: string) => void
}

export const LocationSearchInput: React.FC<Props> = ({ address, updateAddress, onSelect }) => {
  const renderAutocompleteView = props => {
    return <AutocompleteView {...props} />
  }

  return (
    <PlacesAutocomplete
      value={address}
      onChange={updateAddress}
      onSelect={onSelect}
      highlightFirstSuggestion={true}
      shouldFetchSuggestions={address.length > 2}
      debounce={500}
      searchOptions={{ componentRestrictions: { country: 'es' } }}
    >
      {renderAutocompleteView}
    </PlacesAutocomplete>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Forms/LocationInput/Autocomplete/Autocomplete.container.tsx